import { useState, useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';
import { Dialog, DialogContent, DialogTitle, Box, } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DashboardCards from '../../Components/DashboardCards';
import CloseIcon from '@mui/icons-material/Close';
import LargePostCardDialog from '../../Components/LargePostCardDialog';
import { db } from '../../Firebase/firebase';
import {
  collection,
  query,
  where,
  onSnapshot,
} from 'firebase/firestore';
import { useAuth } from '../../contexts/AuthContext';

const SavedPosts = () => {
  const [savedPosts, setSavedPosts] = useState([]);
  const { posts } = useOutletContext();
  const { currentUser } = useAuth(); // Use the AuthContext to get current user
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  //Function to handle SummaryCard click and display LargePostDialog popUp
  const handleCardClick = (cardData) => {
    if (!cardData) {
      console.error('Card data is not available');
      return;
    }
    setSelectedCard(cardData); // cardData now contains category too so above code not needed
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedCard(null);
  };

  useEffect(() => {
    if (currentUser && currentUser.uid) {
      const q = query(
        collection(db, 'savedPosts'),
        where('userId', '==', currentUser.uid)
      );

      // Use onSnapshot to listen for real-time updates in saved posts
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const posts = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setSavedPosts(posts); // Update saved posts in real-time
      });
      // Clean up the subscription when the component unmounts
      return () => unsubscribe();
    }
  }, [currentUser]);

  return (
    <Box sx={{ pt: 0, pl: 0 }}>
      <Box
        sx={{
          gap: 3,
          mt: 1,
          mb: 5,
          p: 1,
          pb:3,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          boxSizing:'border-box',
        }}
      >
        {/* <Grid container spacing={3}> */}
        {savedPosts.map((post) => (
          <DashboardCards
          key={post.id}
          id={post.userId}
            postID={post.id}
            images={post.images || []} // Pass the entire array of images
            title={post.title}
            summary={post.summary}
            photoURL={post.photoURL}
            username={post.username} //pass the username to LargePostCard
            name={post.name}
            email={post.email}
            location={post.location || null}
            date={post.date} //this is ".date" not ".readableDate" becaused when bookmarked, it's saved that way
            category={post.category}
            vertical='230px'
            horizontal='300px'
            deletable={false}
            onClick={() => handleCardClick(post)}
            onDelete={() => handleUnsave(post.id)} // Pass handleUnsave to remove post
          />
        ))}
      </Box>
      {/* PopUp Dialog displaying LargePostCardDialog */}
      {selectedCard && (
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth='lg'
          fullWidth
          PaperProps={{
            style: {
              maxHeight: 'calc(100vh - 15px)',
              overflowY: 'auto',
              height: '85vh',
              borderRadius: '24px',
            },
          }}
        >
          <DialogTitle sx={{ mb: 1, p: 2 }}>
            {/* {selectedCard.title} */}
            <IconButton
              aria-label='close'
              onClick={handleCloseDialog}
              sx={{
                position: 'absolute',
                right: { xs: 2, sm: 2, md: 4, lg: 8, xl: 8 },
                top: { xs: 1, sm: 1, md: 3, lg: 8, xl: 8 },
                color: (theme) => theme.palette.grey[500],
                '&:hover': {
                  backgroundColor: 'indianred',
                  color: 'white',
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent
            sx={{
              mt: 0,
              mb: 0,
              p: 0,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <LargePostCardDialog
              id={selectedCard.userId}
              postID={selectedCard.id}
              images={selectedCard.images}
              title={selectedCard.title}
              summary={selectedCard.description}
              link={selectedCard.link}
              ratings={selectedCard.ratings}
              postInfo={selectedCard} // Pass the whole object
              photoURL={selectedCard.userPhotoURL}
              username={selectedCard.username} //pass the username to LargePostCard
              name={selectedCard.name}
              email={selectedCard.email}
              location={selectedCard.location|| null}
              date={selectedCard.readableDate}
              category={selectedCard.category}
              />
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};

export default SavedPosts;
